import { useTranslation } from 'react-i18next';
import React from 'react';
import { Typography } from 'app/components/ui';
import { TagItemShortcuts } from 'features/tagging/TagItemShortcuts/TagItemShortcuts';

import './Taxonomy.scss';

interface TagTextProps {
  label: string;
  conceptLabel: string;
  icon: React.ReactNode;
  isUsed?: boolean;
  isUsedElsewhere?: boolean;
  isExtension?: boolean;
  isSelected?: boolean;
  onDetailsClick?: () => void;
  onExtensionClick?: () => void;
}

export const TagText = React.memo(
  ({ label, conceptLabel, icon, isUsed, isUsedElsewhere, isExtension, isSelected, onDetailsClick, onExtensionClick }: TagTextProps) => {
    const { t } = useTranslation('tag');

    return (
      <div className={`taxonomy__list-item${isSelected ? ' selected' : ''}`}>
        <span className="taxonomy__icon">{icon}</span>

        <div>
          <div className="flex-row align-items-center my-1">
            <Typography variant="body-3">{conceptLabel}</Typography>

            <div className="mx-2 flex-row align-items-center">
              {isUsed && (
                <span className="taxonomy__tag taxonomy__tag--used" role="status" aria-label={t('used')}>
                  {t('used')}
                </span>
              )}
              {isUsedElsewhere && (
                <span className="taxonomy__tag taxonomy__tag--used-elsewhere" role="status" aria-label={t('used.elsewhere')}>
                  {t('used.elsewhere')}
                </span>
              )}
              {isExtension && (
                <span className="taxonomy__tag taxonomy__tag--extension" role="status" aria-label={t('extension')}>
                  {t('extension')}
                </span>
              )}
            </div>
          </div>
          <Typography variant="body-5">{label}</Typography>
        </div>

        {onDetailsClick && onExtensionClick && (
          <span className="taxonomy__pop-up-icon">
            <TagItemShortcuts
              actions={[
                { type: 'details', onClick: onDetailsClick },
                { type: 'create', onClick: onExtensionClick },
              ]}
            />
          </span>
        )}
      </div>
    );
  }
);
